import { render, staticRenderFns } from "./emailSync.vue?vue&type=template&id=c5867f92&lang=pug"
import script from "./emailSync.vue?vue&type=script&lang=js"
export * from "./emailSync.vue?vue&type=script&lang=js"
import style0 from "./emailSync.vue?vue&type=style&index=0&id=c5867f92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports